import { useEffect, useState } from "react";
import { navLinks } from "../data";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const el = document.getElementById("hot");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <div
        className={`transition-all duration-300 ${
          scrolled
            ? "bg-background-50/90 backdrop-blur-md border-b border-background-200"
            : "bg-transparent border-b border-transparent"
        }`}
      >
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="flex items-center justify-between h-16 md:h-[72px]">
            {/* brand */}
            <a href="#top" className="flex items-center gap-2.5 group">
              <span className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center shadow-sm">
                <i className="ri-camera-lens-fill text-lg md:text-xl"></i>
              </span>
              <span className="font-heading text-xl md:text-2xl font-extrabold tracking-tight text-foreground-950">
                搭讪<span className="text-primary-600">吃瓜</span>
              </span>
            </a>

            {/* desktop nav */}
            <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
              {navLinks.map((l) => (
                <a
                  key={l.id}
                  href={`#${l.id}`}
                  className="px-3 py-2 text-[15px] text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {l.label}
                </a>
              ))}
            </nav>

            {/* actions */}
            <div className="hidden lg:flex items-center gap-3">
              <form onSubmit={submitSearch} className="relative" role="search">
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
                <input
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="搜搭讪争议话题"
                  className="w-44 xl:w-52 h-10 pl-9 pr-3 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400 transition"
                />
              </form>
              <a
                href="#contact"
                className="h-10 px-5 inline-flex items-center rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition whitespace-nowrap"
              >
                投稿爆料
              </a>
            </div>

            {/* mobile toggle */}
            <button
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-800"
              aria-label="打开菜单"
              aria-expanded={open}
            >
              <i className={`ri-${open ? "close-line" : "menu-line"} text-xl`}></i>
            </button>
          </div>
        </div>

        {/* mobile panel */}
        {open && (
          <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 md:px-6 pb-6 pt-3">
            <form onSubmit={submitSearch} className="relative mb-4" role="search">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜搭讪争议话题"
                className="w-full h-11 pl-9 pr-3 rounded-full bg-background-100 border border-background-200 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300"
              />
            </form>
            <nav className="flex flex-col gap-1" aria-label="移动端导航">
              {navLinks.map((l) => (
                <a
                  key={l.id}
                  href={`#${l.id}`}
                  onClick={() => setOpen(false)}
                  className="px-2 py-2.5 text-foreground-700 hover:text-primary-600 text-[15px]"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                className="mt-2 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-sm font-medium"
              >
                投稿爆料
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}